import { render, staticRenderFns } from "./imbalance-table.vue?vue&type=template&id=40b49342&scoped=true&"
import script from "./imbalance-table.vue?vue&type=script&lang=ts&"
export * from "./imbalance-table.vue?vue&type=script&lang=ts&"
import style0 from "./imbalance-table.vue?vue&type=style&index=0&id=40b49342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b49342",
  null
  
)

export default component.exports